module.exports = __webpack_public_path__ + "static/media/addedmenu.172b30dd.jpg";